module.exports = __webpack_public_path__ + "static/serviceBgOne-ea8510b6e5740bade68f4011d5fd4c66.jpg";